export const GET_AVAILABILITYS = 'GET_AVAILABILITYS'
export const SET_AVAILABILITYS = 'SET_AVAILABILITYS'
export const SET_AVAILABILITY_STATE = 'SET_AVAILABILITY_STATE'
export const REMOVE_AVAILABILITY = 'REMOVE_AVAILABILITY'

export enum ORDER_RESPONSE {
   GET_AVAILABILITY_SUCCESS,
   GET_AVAILABILITY_ERROR,
}
